import React, {Component, Fragment, useEffect, useRef, useState} from "react";
import {NavLink} from "react-router-dom";
import queryString from "query-string";
import 'rc-slider/assets/index.css';
import * as moment from "moment";
import {PropTypes} from 'prop-types';
import {BrowserView, isMobile} from 'react-device-detect';
import {CSSTransition} from 'react-transition-group';

import {
	changeState,
	countMap,
	extractCartData,
	forEachObj,
	formatPrice,
	getNestedValue,
	historyPrev,
	isEmpty,
	mapArrayToObject,
	mapObject,
	mapObjectToArray,
	objectFind,
	relativePath,
	toggleState
} from "../lib/tools";
import {BackBtn, Button, Image, InfinityScroll, QtySelector, RelativeRoute, SearchField} from "../components/common/common";
import {DatetimeInput, DropDown, FormInput} from "../components/common/formValidation";
import {ProductModal} from "../components/common/modal";
import {reduxWrapper} from "../globalState";
import {getImage} from "../lib/api";
import {ModalContext} from "../contexts";
import goodToKnow from '../goodToKnow';
//Icons
import cartGreyIcon from "../resources/icons/basket-grey.svg";
import cartWhiteIcon from "../resources/icons/basket-white.svg";
import dropDownIcon from "../resources/icons/downArrow-black.svg";

//<editor-fold desc="Store View"

class StoreViewRender extends Component {
	static propTypes = {
		sections: PropTypes.object,
		section: PropTypes.object
	}
	
	state = {
		loading: true,
		filters: {},
		search: "",
		productList: [],
		products: [],
		productType: null,
		productTypes: {},
		searchInfo: {},
		loadKey: null,
		isRentable: null,
		footerExtended: false
	};
	
	mounted = true;
	itemsPerPage = 18;
	updateTimeout = null;

	loadMore = () => {
		let self = this;
		return new Promise(function (resolve, reject) {
			let state = self.state;
			const loadKey = self.state.loadKey;
			self.props.fetchProducts({
				section: self.props.section.id,
				afterLoad: data => {
					if (!self.mounted || self.state.loadKey !== loadKey) return resolve(0);
					
					self.setState(prev => ({
						loading: false,
						productList: [...prev.productList, ...data.map(x => x.id)],
						searchInfo: mapArrayToObject(data, x => x.searchInfo && {
							key: x.id,
							data: x.searchInfo
						})
					}));
					resolve(data.length);
				},
				data: {
					search: state.search,
					productType: state.productType,
					isRentable: state.isRentable,
					limitOffset: state.productList.length,
					limit: self.itemsPerPage
				}
			});
		});
	};

	updateFilter = (state) => {
		clearTimeout(this.updateTimeout);
		const loadKey = state.search + state.productType;
		if (loadKey !== this.state.loadKey) {
			this.updateTimeout = setTimeout(() => {
				this.setState({productList: [], loadKey, loading: true});
			}, 600);
		}
	};

	onFilterChange = (name, val) => {
		var state;
		if (name === "productType" && val === this.state[name]) {
			state = {...this.state, [name]: null};
		} else {
			state = {...this.state, [name]: val};
		}
		
		this.setState(state);
		
		if ((name === "productType" || name === "search") && state[name] !== this.state[name]) {
			this.updateFilter(state);
		}
		
		const query = {};
		
		if (state.productType) query.pt = state.productType;
		if (state.search) query.q = state.search;
		this.props.history.replace({
			...this.props.location,
			search: isEmpty(query) ? null : queryString.stringify(query)
		});
	};
	
	toggleFooter = () => {
		this.setState(toggleState("footerExtended"));
	}
	
	componentWillMount() {
		this.props.apiCall("GET", `/section/${this.props.section.id}/types`, data => (!isEmpty(data) && this.setState({
			productTypes: data
		})));
		const query = queryString.parse(window.location.search) || {};
		this.setState({
			productType: query.pt || null,
			search: query.q || "",
			isRentable: query.lej != null ? parseInt(query.lej, 10) === 1 : null
		});
	}
	
	componentWillUnmount() {
		this.mounted = false;
		clearTimeout(this.updateTimeout);
	}

	recommended = {
		25: [583, 578, 27570, 21258, 16886, 8682, 32731, 582],          // Snacks
		11: [8771, 8772, 1153, 1196, 1266, 1073, 305, 1226],            // Spiritus
		12: [866, 852, 933, 883, 962, 899, 875, 825],                   // Vin
		13: [104, 122, 775, 785, 779, 144, 771, 746],                   // øl
		14: [428, 8733, 7481, 664, 5492, 8444, 445, 449],               // Sodavand
		4: [6812, 6811, 3704, 7936, 2694, 17056, 7724, 3694],           // Bordkort
		10: [35507, 35504, 34991, 14409, 53, 569, 34625, 716],          // Borddækning
		19: [5678, 5653, 5618, 5602, 5611, 8524, 5699, 5688],           // Blomster
		20: [7376, 2514, 3127, 3299, 3231, 34615, 34617, 30449],        // Balloner
		18: [5523, 5586, 5547, 23798, 15555, 5560, 33178, 29559],       // Lyd og Lys
		17: [33781, 30846, 20355, 23609, 35118, 34874, 34433, 34467],   // Udklædning
		27: [4999, 21283, 675, 34258, 25396, 24869, 261, 39],           // Popkorn
		5: [5021, 4989, 5007, 4991, 5297, 4985, 5293, 4995],            // Telt
		6: [5276, 5042, 5041, 5150, 5267, 5208, 5111, 5028]             // Moebler
	}
	
	render() {
		const {section: {id, title, code}, cart, productTypes} = this.props;
		const {total, products} = (extractCartData(cart, this.props.products, null, id));
		return (
			<div className={`storeViewContainer${products.length > 0 ? " withProducts" : ""}`} ref="storeCont">
				<RelativeRoute path=":id" render={({match: {params: {id: productId}}, history}) => (
					<ProductModal onHide={() => historyPrev(history)} section={title}>
						<ProductInfo key={productId} sectionId={id} id={Number(productId)}
						             toggleFooter={this.toggleFooter}/>
					</ProductModal>
				)}/>
				
				<div className="storeTop">
					<div className="maxWidth">
						<h1 className="title-m">{title}</h1>
						<BackBtn to={relativePath("../")}/>
						<SearchField 
							value={this.state.search}
							onChange={val => this.onFilterChange("search", val)}
						/>
					</div>
				</div>
				
				<div className="storeViewWrapper" id="storeView">
					{goodToKnow[code] &&
					<div className="goodToKnowWrapper maxWidth">
						<img src={getImage(goodToKnow[code].image)}/>
						<div className="textWrapper">
							<span>{goodToKnow[code].title}</span>
							<h1 className="title-m">{goodToKnow[code].text}</h1>
						</div>
					</div>
					}
					<div className="storeViewOptions sticky">
						{!isEmpty(this.state.productTypes) &&
						<AttributeSlider sectionTypes={this.state.productTypes} chosenType={this.state.productType}
						                 allTypes={productTypes} onFilterChange={this.onFilterChange}/>
						}
					</div>
					{
						!this.state.productType && this.state.search === "" && this.id !== 9 && this.recommended[id] && 
						<Fragment>
							<div className="title-m maxWidth">Anbefalede</div>
							<div className="productList maxWidth reccomendedList">
								{	
									this.recommended[id].map(x => <ProductPreview key={x} id={x} searchInfo={this.state.searchInfo[x]} sectionId={id} recommended/>)
								}
							</div>
						</Fragment>
					}

					<div className="maxWidth title-m">{this.state.productType ? this.state.productTypes[this.state.productType] : "Alle produkter"}</div>
					<ProductList
						key={this.state.loadKey}
						products={this.state.productList}
						searchInfo={this.state.searchInfo}
						loading={this.state.loading}
						loadMore={this.loadMore}
						sectionId={id}
						cart={cart}
						section={title}
					/>

				</div>
				<StoreViewFooter 
					title={title} 
					total={total} 
					products={products} 
					extended={this.state.footerExtended}
					onToggle={this.toggleFooter} 
				/>
			
			</div>
		);
	}
}

export const StoreView = reduxWrapper("getApiCall", "getFetchProducts", "loadCart", "loadProducts", "loadProductTypes")(StoreViewRender);

//</editor-fold>

export const AttributeSlider = ({allTypes, chosenType, sectionTypes, onFilterChange}) => {
	const [scrollCtr, setScrollCtr] = useState(false);
	
	const filterWrapper = useRef(null);
	const sliderWrapper = useRef(null);

	const scroll = direction => {
		let element = document.getElementsByClassName("attrSliderWrapper")[0];
		let scroll = element.scrollLeft;
		let childWidth = element.children[0].offsetWidth;
		if (direction === "left") {
			element.scroll({
				left: scroll - (childWidth * 4),
				behavior: 'smooth'
			});
		} else {
			element.scroll({
				left: scroll + (childWidth * 4),
				behavior: 'smooth'
			});
		}
	}
	
	useEffect(() => {
		if (filterWrapper.current.offsetWidth - sliderWrapper.current.scrollWidth < 0) {
			setScrollCtr(true);
		}
	});

	return (
		<div className="attributeFilterWrapper maxWidth" ref={filterWrapper}>
			{scrollCtr &&
				<Fragment>
					<BrowserView>
						<div className="navLeft" onClick={() => scroll("left")}>
							<img src={dropDownIcon} alt="Vøjre"/>
						</div>
					</BrowserView>
					<div className="fadeLeft"/>
				</Fragment>
			}
			<div className="attrSliderWrapper" ref={sliderWrapper}>
				{mapObjectToArray(sectionTypes, (x, i) =>
					<div
						key={i}
						className={sectionTypes[chosenType] === x ? "productType chosen" : "productType"}
						onClick={() => onFilterChange("productType", i)}
					>
						<div className="typeImg">
							<img src={allTypes[i] ? getImage(allTypes[i].image) : getImage(19)} alt={x}/>
						</div>
						<span>{x}</span>
					</div>
				)}
			</div>
			{scrollCtr &&
				<Fragment>
					<div className="fadeRight"/>
					<BrowserView>
						<div className="navRight" onClick={() => scroll("right")}>
							<img src={dropDownIcon} alt="Venstre"/>
						</div>
					</BrowserView>
				</Fragment>
			}
		</div>
	)
};

class StoreViewFooterRender extends Component {
	state = {
		edit: false
	}
	
	onIncrement = (val, prodId) => {
		if (val > 0) {
			this.props.updateCart({id: prodId, data: {qty: val}});
		} else {
			this.props.deleteCart({id: prodId});
			if(this.props.products.length < 1){
				this.props.onToggle();
			}
		}
	}

	render() {
		const {title, total, products, deleteCart, extended, onToggle} = this.props;
		const productCount = countMap(products, x => x.qty);
		return (
			<Fragment>
				<CSSTransition
					classNames="bgDark"
					timeout={300}
					in={extended}
					unmountOnExit
				>
					<div className="bgDark"/>
				</CSSTransition>
				<div className={["storeViewFooter", extended ? "extended" : "folded"].join(" ")} onClick={products.length > 0 || extended ? onToggle : null}>
					<div className="maxWidth">
						<div className="footerTopWrapper">
							<div className="footerTitleWrapper">
								<div className="footerTitle">
									<div className="line"/>
									<div className="title-m">{title}</div>
								</div>
								{/* <span key={productCount} className="prodQty bounce">{productCount} produkt{productCount === 1 ? "" : "er"}</span> */}
								<span key={productCount}
								      className="prodPrice bounce">{`${formatPrice(total)} kr i alt`}</span>
							</div>
							<Button className="light" onClick={e => e.stopPropagation()} to={"/konkurrence/byg"}>Din fest</Button>
						</div>
						<div className="extendedContent" onClick={e => e.stopPropagation()}>
							<div className="storeFooterProdWrapper">
								{
									products.map((x, i) =>
										<div key={i} className="footerProductWrapper">
											<div className="prodInfo">
												<img src={getImage(x.product.thumbnail)} alt={x.product.name}/>
												<div className="prodText">
													<span className="prodName">{x.qty} x {x.product.name}</span>
													<span className="prodPrice">{formatPrice(x.price)}</span>
												</div>
											</div>
											<div className="prodSettings">
												<QtySelector value={x.qty} onChange={val => this.onIncrement(val, x.id)}
												             min={0}/>
												<span onClick={() => deleteCart({id: x.id})}>Fjern</span>
											</div>
											<div className="prodTotalPrice">
												<span>{formatPrice(Number(x.price) * x.qty)} kr</span>
											</div>
										</div>
									)
								}
							</div>
							<div className="sectionPrice">
								<div className="mainPrice">
									<img src={cartGreyIcon} alt="Kurv"/>
									<span>Subtotal {formatPrice(total)} kr</span>
								</div>
							</div>
							<div className="prodFooterAction">
								<Button to={"/konkurrence/byg"} className="light">Tilbage til Min fest</Button>
								<Button onClick={onToggle}>Fortsæt med at handle</Button>
							</div>
						</div>
					</div>
				</div>
			</Fragment>
		)
	}
}

const StoreViewFooter = reduxWrapper("loadPartyInfo", "updateCart", "deleteCart")(StoreViewFooterRender);


//<editor-fold desc="Product Preview">
const ProductList = ({products, searchInfo, loading, loadMore, loadKey, sectionId, section}) => (
	<InfinityScroll className={`productList maxWidth productList${section}`} loadCount={18} loadMore={loadMore}
	                loadKey={loadKey} parent="storeView">
		{
			products.length > 0 ?
				products.map(x => <ProductPreview key={x} id={x} searchInfo={searchInfo[x]} sectionId={sectionId}/>) :
				(!loading && <span className="noProducts">Vi kunne ikke finde nogen produkter til dig.</span>)
		}
	</InfinityScroll>
);

export class ProductPreviewRender extends Component {
	cartId = null;
	
	isInCart = (cart, prodId) => {
		let qty = 0;
		forEachObj(cart, x => {
			if (x.productId === prodId) {
				qty += x.qty;
				this.cartId = x.id;
			}
		});
		return qty;
	}

	setGuests = (qty) => {
		if(this.props.sectionId === 9){
			this.props.setPartyInfo({
				data: {
					guests: qty
				}
			})
		}
	}
	
	onAddToCart = (qty) => {
		this.props.addCart({
			data: {
				productId: this.props.id,
				qty: qty,
				section: this.props.sectionId,
			},
			success: "",
			showError: true
		});

		this.setGuests(qty);
	}
	
	onIncrement = (val) => {
		if (this.props.sectionId === 9) {
			if (val > 9) {
				this.props.updateCart({id: this.cartId, data: {qty: val}});
				this.setGuests(val);
			} else {
				this.props.deleteCart({id: this.cartId});
				this.setGuests(1);
			}
		} else {
			if (val > 0) {
				this.props.updateCart({id: this.cartId, data: {qty: val}})
			} else {
				this.props.deleteCart({id: this.cartId})
			}
		}
	}

	render() {
		const {id, products, cart, partyInfo: {guests}, recommended = false} = this.props;
		const product = {...products[id], cartQty: this.isInCart(cart, id)} || {};
		const {name, thumbnail, price, searchInfo, info = {}, shortDescription} = product;
		return (
			<div className={product.cartQty ? "productPreview chosen" : "productPreview"}>
				{ // Make sure products are cached
					product.cartQty || recommended ? <ProductPreviewLoad id={id}/> : null
				}
				
				<NavLink to={relativePath(id)}>
					{/* TODO: Remember to style if to keep */}
					{searchInfo && <span className="searchInfo">{searchInfo}</span>}
					{info.rent ? <span className="rentTag">UDLEJES</span> : "" }
					<div className="imageWrapper">
						<Image src={getImage(thumbnail)} alt={name}/>
					</div>
					<div className="prodPrevInfo">
						<div className="productTitleWrapper">
							<h4 className="productTitle">{name}</h4>
							{product.sections && product.sections.includes("9") && 
								<p className="block-with-text" style={{whiteSpace: "pre-line"}}>{shortDescription}</p>
							}
						</div>
						{this.props.sectionId === 9 && <span className="prPerson"> pr person</span>}
					</div>
				</NavLink>
				
				<div className="prodPrevAction">
					<span className="price">
						{price && formatPrice(price)}
					</span>
					{
						info.rent ?
							<NavLink to={relativePath(id)} className="addToCart ga-butikAddToCartLeje">
								<img src={cartWhiteIcon} alt="Kurv"/>
							</NavLink> :
							product.customOptions && product.customOptions.filter(x => !x.checkout).length > 0 ?
								<NavLink to={relativePath(id)} className="addToCart ga-butikAddToCartLeje">
									<img src={cartWhiteIcon} alt="Kurv"/>
								</NavLink> :
								product.cartQty ?
								<QtySelector value={product.cartQty} onChange={val => this.onIncrement(val)}
								min={0}/> : 
								<div className="addToCart ga-butikAddToCart">
									<img src={cartWhiteIcon} onClick={this.props.sectionId === 9 ? () => this.onAddToCart(guests > 9 ? guests : 10) : () => this.onAddToCart(1)} alt="Kurv"/>
								</div>
					}
				</div>
			</div>
		)
	}
}
const ProductPreview = reduxWrapper("loadProducts", "addCart", "updateCart", "deleteCart", "loadCart", "setPartyInfo")(ProductPreviewRender);

//</editor-fold>

class ProductPreviewLoadRender extends Component {
	componentWillMount() {
		this.props.cacheProduct({product: this.props.id, full: true})
	}
	
	render() {
		return null;
	}
}

const ProductPreviewLoad = reduxWrapper("getCacheProduct")(ProductPreviewLoadRender);


//<editor-fold desc="Product Info">
class ProductInfoRender extends Component {
	static contextType = ModalContext;
	
	state = {
		qty: 1,
		configuration: {},
		customOptions: {},
		showError: false,
		image: null,
		children: {}
	};
	
	componentWillMount() {
		if (!this.props.id) return;
		this.props.cacheProduct({product: this.props.id, full: true}).then(products => {
			this.setState({qty: getNestedValue(products, [this.props.id, "info", "minQty"]) || 1});
			const children = getNestedValue(products, [this.props.id, "children"]) || [];
			if (children.length > 0) {
				this.props.cacheProduct({products: children, full: false});
			}
		});
	}
	
	onConfigChange = (config, value) => {
		const {products, id} = this.props;
		const product = products[id] || {};
		this.setState(changeState(["configuration", config], value));
		product.configTree && this.moveDownTree(product.configTree);
		this.setState({image: this.image})
	}
	
	moveDownTree(level) {
		const {products, id} = this.props;
		const product = products[id];
		if (level.configId) {
			const config = product.configurations && product.configurations.find(x => x.id === level.configId);
			
			if (config) {
				this.configId = level.configId;
				this.price = config.price;
				this.qty = config.qty;
				this.image = config.imageId || null;
			}
			return;
		}
		this.options[level.attribute] = mapObject(level.options, (x, i) => this.props.options[i] && this.props.options[i]);
		
		let val = this.state.configuration[level.attribute];
		if (val && level.options.hasOwnProperty(val))
			return this.moveDownTree(level.options[val]);
		
		this.configId = null;
		this.price = null;
		this.qty = null;
		this.image = level.image || null;
	}
	
	onPurchase = () => {
		const product = this.props.products[this.props.id];
		if (!product || !product.full)
			return;
		
		if (this.state.qty < 1) return;
		
		if (product.configurations && product.configurations.length > 0) {
			if (!this.configId) {
				this.setState({showError: true});
				return;
			}
		}
		
		if (product.customOptions) {
			for (let key in product.customOptions.filter(x => !x.checkout)) {
				if (!product.customOptions.hasOwnProperty(key)) continue;
				if (!this.state.customOptions[product.customOptions[key].id]) {
					this.setState({showError: true});
					return;
				}
			}
		}
		
		const customOptions = mapObject(this.state.customOptions, x => moment.isMoment(x) ? x.format("YYYY-MM-DD HH:mm:ss") : x);
		
		this.props.addCart({
			data: {
				productId: this.props.id,
				qty: this.state.qty,
				configurationId: this.configId,
				section: this.props.sectionId,
				customOptions: customOptions
			},
			success: this.props.history.push("././"),
			showError: true
		});
		
		this.props.cacheProduct({product: this.props.id, full: true});

		if(product.sections && product.sections.includes("9")){
			this.props.setPartyInfo({
				data: {
					guests: this.state.qty
				}
			})
		}
	}
	
	cartId = null;
	isInCart = (cart, prodId) => {
		let qty = 0;
		forEachObj(cart, x => {
			if (Number(x.productId) === Number(prodId)) {
				qty += x.qty;
				this.cartId = x.id;
			}
		});
		return qty;
	}
	
	onIncrement = (val) => {
		if (val === this.state.qty) {
			this.props.deleteCart({id: this.cartId})
		} else {
			this.props.updateCart({id: this.cartId, data: {qty: val}});
			this.setState({qty: val});
		}
	}
	
	render() {
		const {products, id, attributes, cart} = this.props;
		const product = {...products[id], cartQty: this.isInCart(cart, id)} || {};
		const {sections, name, price, description, configAttributes, customOptions, configTree, images = [], qty, info, full, children = []} = product;
		const {minQty} = info || {};
		this.options = {};
		configTree && this.moveDownTree(configTree);
		const cartItem = objectFind(cart, x => x.productId === id && (!x.configurationId || x.configurationId === this.configId));
		
		const inCart = cartItem ? cartItem.qty || 0 : 0;
		const alternateView = children.length > 0;

		return (
			<div className={"productInfoWrapper" + (alternateView ? " alterante" : " basic")}>
				<div className="productInfo">
					{/* <Carousel images={images} value={this.state.image} onChange={image => this.setState({image})}/> */}
					{isMobile ?
						<div className="imgContainer">
							<div className="gradiantContainer" style={{
								backgroundImage: `linear-gradient(rgba(255, 255, 255, .9), rgba(255, 255, 255, .2) 25%), linear-gradient(to top, rgba(41, 93, 97, 0.5), rgba(41, 93, 97, 0) 40%)`
							}}/>
							<img src={getImage(images[0])}/>
						</div> :
						<div
							className={["imgContainer", sections && sections.includes("9") ? "foodImgContainer" : ""].join(" ")}>
							<div className={"gradiantContainer"}
							     style={{
								     backgroundImage: `linear-gradient(to bottom, #ffffff, rgba(255, 255, 255, 0.81) 0%, rgba(255, 255, 255, 0) 18%)`
							     }}/>
							<img src={getImage(images[0])}/>
						</div>
						
					}
					
					<div className="productDetailsWrapper">
						
						<div className="productDetails">
							<h1 className="title-l">{name}</h1>
							
							<div className="productDescriptionWrapper"
							     dangerouslySetInnerHTML={{__html: full ? (description ? description : "Ingen beskrivelse") : "Henter..."}}
							/>
							<div className="productSettings">
								{configAttributes && configAttributes.map(x =>
									<DropDown
										key={x} req showError={this.state.showError}
										value={this.state.configuration[x]}
										externalLabel={true}
										onChange={val => this.onConfigChange(x, val)}
										title={attributes[x]}
										options={this.options[x] || {}}
									/>
								)}
								{customOptions && customOptions.filter(x => !x.checkout).map(x =>
									<CustomOption showError={this.state.showError}
									              {...x} key={x.id}
									              value={this.state.customOptions[x.id]}
									              onChange={val => this.setState(changeState(["customOptions", x.id], val))}
									/>
								)}
							
							</div>
						</div>
						
						<div className="buyBtnContainer">
							<span className="price">
								{formatPrice(this.price || price)}
							</span>
							
							<div className="formControls">
								{inCart ?
									<QtySelector
										value={inCart}
										onChange={val => this.onIncrement(val)}
										max={Math.min(99, this.qty || qty)} min={minQty || 1}
									/> :
									<QtySelector
										value={parseInt(this.state.qty, 10)}
										onChange={val => this.setState({qty: val})}
										max={Math.min(99, this.qty || qty)} min={minQty || 1}
									/>
								}
							</div>
							
							{inCart ?
								<Fragment>
									<span className="inCart">
										Du har allerede {inCart} af dette produkt i kurven
									</span>
								</Fragment> :
								<Button className="buy ga-sppBuy" type="submit" onClick={this.onPurchase}>
									Tilføj til kurv
								</Button>
							}
						</div>
					</div>
					
					{/* {alternateView &&
						<div className="productAlternate">
							{children.map(x => {
								const product = products[x];
								if (!product || !product.name) return null;
								return (
									<Link to={relativePath(`../${x}`)}>
										<div className="productChild" key={x}>
											<Image src={product.thumbnail}/>
											<p className="name">{product.name}</p>
											<p className="price">{formatPrice(product.price)}</p>
										</div>
									</Link>
								);
							})}
						</div>
					} */}
				
				</div>
			</div>
		);
	}
}

const ProductInfo = reduxWrapper("loadProducts", "loadOptions", "loadAttributes", "deleteCart", "loadCart", "updateCart", "getCacheProduct", "addCart", "setPartyInfo")(ProductInfoRender);

class CustomOptionRender extends Component {
	componentWillMount() {
		const {type, onChange, value, partyInfo} = this.props;
		if (type === "date" || type === "datetime" || type === "time") {
			onChange(value || (partyInfo.time ? moment(partyInfo.time).hour(18).minute(0) : null))
		}
	}
	
	render() {
		const {type, name, onChange, value, showError, disabled = false} = this.props;
		return (
			<div className="customOption">
				{type === "string" ? <FormInput name={name} value={value} title={name} req showError={showError}/> :
					type === "date" ?
						<DatetimeInput value={value} onChange={onChange} title={name} req showError={showError} disabled={disabled}/> :
						type === "datetime" ?
							<DatetimeInput value={value} onChange={onChange} time={true} title={name} req
							               showError={showError} placeholder="Vælg dato og tid" disabled={disabled}/> :
							type === "time" ?
								<DatetimeInput value={value} onChange={onChange} date={false} title={name} req
								               showError={showError} disabled={disabled}/> :
								<FormInput name={name} title={name} req showError={showError}/>
				}
			</div>
		);
	}
}
export const CustomOption = reduxWrapper("loadPartyInfo")(CustomOptionRender);
//</editor-fold>


export default StoreView;



// WEBPACK FOOTER //
// ./src/contest/storeView.js